exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan.error[data-v-3f615e54]{\n  color:#dc3545\n}\ninput.error[data-v-3f615e54]{\n  border-color:#dc3545\n}\n\n", ""]);

// exports
